export default class Action {
  constructor({ actionName, title, userInfo, module, instance, displayLocation, objectType, sendboxItem }) {
    this.actionName = actionName;
    this.title = title;
    this.userInfo = userInfo;
    this.displayLocation = displayLocation;
    this.module = module;
    this.instance = instance;
    this.objectType = objectType;
    this.sendboxItem = sendboxItem;
  }
}
